<p-toast [style]="{marginTop: '80px'}"></p-toast>
 <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<h6 class="prd-h6"> System Audit Trail </h6>
<div class="card" >
    <div class="card-body" *ngIf = 'displayState.workingDiv'>
        <div class="row" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
        </div>
        <div class="row">
            <div class="col-md-2 offset-5">
                <!-- <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner> -->
            </div>
        </div>
    </div>
</div>
<br />

<div class="row" *ngIf = '!this.displayState.workingDiv && displayState.gridDiv'>
  <div class="col-md-10 offset-1">
    <p-table #auditListTable styleClass="p-datatable-striped p-datatable-gridlines"
             [value]="auditList" [scrollable]="true" scrollHeight="600px"
             (onFilter)="onFilter($event, auditList)"
             [showCurrentPageReport]="true"
             [rows]="10"
             [rowsPerPageOptions]="[10, 25, 50, 100]"
             [paginator]="true"
             [resizableColumns]="true"
             columnResizeMode="expand"
    >
      <ng-template pTemplate="caption" style="height: 20px;">
        <div class="flex">
          <button pButton label="Clear Filters" class="p-button-outlined" (click)="clearTable(auditListTable)"></button>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
          <tr style="font-size:smaller">
              <th [pSortableColumn]="'creationDate'" style="width: 10%">
                Creation Dt
                <!--<p-columnFilter type="date" field="creationDate" matchMode="equals" display="menu">
                </p-columnFilter>-->
                <p-sortIcon [field]="'creationDate'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'userId'" style="width: 15%" >
                  User
                <p-columnFilter type="text" field="userId" matchMode="contains" display="menu">
                </p-columnFilter>
              </th>
              <th [pSortableColumn]="'moduleName'" style="width: 10%">
                  Module Name
                <p-columnFilter type="text" field="moduleName" matchMode="contains" display="menu">
                </p-columnFilter>
              </th>
              <th [pSortableColumn]="'eventDesc'" style="width: 55%">
                Event Description
                <p-columnFilter type="text" field="eventDesc" matchMode="contains" display="menu">
                </p-columnFilter>
              </th>
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-audit>
          <tr style="font-size: small;">
            <td style="width: 10%">{{audit.creationDate | date:"MM/dd/yyyy HH:mm"}}</td>
              <td style="width: 15%">{{audit.userId }}</td>
              <td style="width: 10%">{{audit.moduleName}}</td>
              <td style="width: 55%">{{audit.eventDesc}}</td>
          </tr>
      </ng-template>
    </p-table>
  </div>
</div>
